import { render, staticRenderFns } from "./TicketBitacora.vue?vue&type=template&id=31d7a85c&scoped=true"
import script from "./TicketBitacora.vue?vue&type=script&lang=js"
export * from "./TicketBitacora.vue?vue&type=script&lang=js"
import style0 from "./TicketBitacora.vue?vue&type=style&index=0&id=31d7a85c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d7a85c",
  null
  
)

export default component.exports